import axios from 'axios';

import { constants, gql } from '@skunexus/utils';

const {
    CONFIG: { API_PATH },
} = constants;

export const fetchProduct = ({ id }) =>
    gql.getGraphQLDetails({
        url: `${API_PATH}/query`,
        config: {
            domain: 'product',
        },
        fields: `
          id
          sku
          customValues {
            custom_field_id
            value
          }
        `,
        payload: { id },
    });
